<template>
  <div class="md-3">
    <ErrorMessage name="bibTipoDocumento" />
  </div>

  <div class="col-md-12">
    <ConsulteGrid :columns="rows" :data-source="dataSource" :actions="true" @on-change-data-row="rowChange">
      <template #botaoExemplar="context">
        <button type="button" class="btn btn-outline-warning" @click="exemplar(context.row)">
          Exemplar
        </button>
      </template>
    </ConsulteGrid>
  </div>
</template>

<script lang="ts">
import ConsulteGrid from '@/components/grid/ConsulteGrid.vue';
import { ConsulteGridColumnsModel, FiltrosModel } from '@/datasources/consulte-grid';
import { defineComponent } from 'vue';
import BibDocumentoPesquisaDataSource from '@/datasources/biblioteca/bibdocumentopesquisa/index.datasource';
import { BibDocumentoPesquisaModel } from '@/models/biblioteca/bibdocumento/bibdocumentopesquisa.model';
import router from '@/routes';
import servicoTipoDocumento from '@/services/biblioteca/bibtipodocumento/bibtipodocumento.service';

export default defineComponent({
  name: 'BibDocumentoGridIndex',
  mounted() {},
  components: { ConsulteGrid },

  methods: {
    rowChange(value: String, row: BibDocumentoPesquisaModel) {
      console.log(value);
      console.log(row);
    },

    async exemplar(row: BibDocumentoPesquisaModel) {
      const isCentral =
        this.$route.path.endsWith('/0') || this.$route.name === 'bibexemplarcentral';

      await router.push({
        name: isCentral ? 'bibexemplar_grid_central' : 'bibexemplar_grid_escola',
        params: { bibDocumentoId: row.bibDocumentoId },
      });
    },
  }, 

  data() {
    return {
      bibTipoDocumentoId: 0 as number,
      dataSource: new BibDocumentoPesquisaDataSource(0, 10, 0, 0, []),
      rows: [
        {
          text: 'Exemplar',
          align: 'center',
          cellsalign: 'center',
          datafield: 'botaoExemplar',
          editable: false,
          filtertype: 'text',
          filterable: false,
        },
        {
          text: 'Título',
          align: 'center',
          cellsalign: 'center',
          datafield: 'titulo',
          editable: false,
          filtertype: 'text',
          filterable: true,
        },
        {
          text: 'Sub Título',
          align: 'center',
          cellsalign: 'center',
          datafield: 'subTitulo',
          editable: false,
          filtertype: 'text',
          filterable: true,
        },
        {
          text: 'Tipo Documento',
          visible: false,
          align: 'center',
          cellsalign: 'center',
          datafield: 'tipoDocumento',
          filtertype: 'autocomplete',
          filterlistpromise: servicoTipoDocumento.DropDownList,
          filtervaluefield: 'texto',
          filtertextfield: 'texto',
          filtermode: 'single',
          conditionbetweenfilters: 'or',
          editable: false,
          filterable: true,
        },
        {
          text: 'Autor',
          align: 'center',
          cellsalign: 'center',
          datafield: 'autor',
          editable: false,
          filtertype: 'text',
          filterable: true,
        },
        {
          text: 'Número Exemplares',
          align: 'center',
          cellsalign: 'center',
          datafield: 'numeroExemplares',
          editable: false,
          filtertype: 'text',
          filterable: false,
        },
        {
          text: 'Tem Exemplar',
          hidden: true,
          align: 'center',
          cellsalign: 'center',
          datafield: 'TemExemplar',
          editable: false,
          filtertype: 'checkbox',
          filterable: true,
        },
      ] as ConsulteGridColumnsModel[],
    };
  },
  created() {
    if (!this.dataSource.filters || this.dataSource.filters.length === 0) {
      const filtroTemExemplar = new FiltrosModel('TemExemplar');
      filtroTemExemplar.addFilter('TemExemplar', 'true', 'pt-Br', 'equals', 'equals', 'TemExemplar');
      this.dataSource.filters = [filtroTemExemplar];
    }
  },
});
</script>
